var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-1" }, [
    _c(
      "div",
      [
        _vm.showModalEditarOficio
          ? _c("modal-editar-oficio", {
              attrs: {
                documentoId: _vm.oficioAtual.id,
                oficio: _vm.oficioAtual,
                titulo: "Editar Ofício"
              },
              on: {
                closeModal: _vm.closeModalEditarOficio,
                onUpdatePDF: _vm.onUpdatePDF
              }
            })
          : _vm._e(),
        _vm.bytes
          ? _c("app-pdf-slider", {
              attrs: {
                documentosBytes: _vm.arrayBytes,
                primeiroDocumento: _vm.primeiroDocumento
              },
              on: { changePdfDownload: _vm.changePdfDownload }
            })
          : _vm._e()
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "mt-1" },
      [
        _c("el-button", { on: { click: _vm.openModalEditarOficio } }, [
          _c("i", { staticClass: "fal fa-file-pdf" }),
          _c("span", [_vm._v("  Editar ofício")])
        ]),
        _c("el-button", { on: { click: _vm.excluirCertidao } }, [
          _c("i", { staticClass: "fal fa-trash red" }),
          _c("span", [_vm._v("  Excluir")])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b5ecafa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b5ecafa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/components/oficio/ConfirmarDados.vue
// module id = null
// module chunks = 